import {Level1} from "~/js/game/levels/Level1";
import { TutorialStepsValues } from "~/js/prefabs/game/Tutorial";

export const LevelName = {
  Level1: 'level1',
  Level2: 'level2',
  Level3: 'level3',
  Level4: 'level4',
  Level5: 'level5',
  Level6: 'level6',
  Level7: 'level7',
  Level8: 'level8',
  Level9: 'level9',
  Level10: 'level10',
  Level11: 'level11',
  Level12: 'level12',
  Level13: 'level13',
  Level14: 'level14',
  Level15: 'level15',
  Level16: 'level16',
} as const;
export type LevelNameKeys = keyof typeof LevelName;
export type LevelNameValues = typeof LevelName[LevelNameKeys];

export const LevelMapName = {
  Level1: 'Desert-Level1',
  Level2: 'Desert-Level2',
  Level3: 'Desert-Level3',
  Level4: 'Desert-Level4',
  Level5: 'Country-Level1',
  Level6: 'Country-Level2',
  Level7: 'Country-Level3',
  Level8: 'Country-Level4',
  Level9: 'Ice-Level1',
  Level10: 'Ice-Level2',
  Level11: 'Ice-Level3',
  Level12: 'Ice-Level4',
  Level13: 'Space-Level1',
  Level14: 'Space-Level2',
  Level15: 'Space-Level3',
  Level16: 'Space-Level4',
} as const;
export type LevelMapNameKeys = keyof typeof LevelMapName;
export type LevelMapNameValues = typeof LevelMapName[LevelMapNameKeys];

export const TileName = {
  Tile_0: 'Tile_0',
} as const;
export type TileNameKeys = keyof typeof TileName;
export type TileNameValues = typeof TileName[TileNameKeys];

// export const LevelState = {
//   Purchased: 'Purchased',
//   Unlocked: 'Unlocked',
//   Locked: 'Locked'
// } as const;
// export type LevelStateKeys = keyof typeof LevelState;
// export type LevelStateValues = typeof LevelState[LevelStateKeys];

export interface Level {
  id: LevelNameValues;
  smashLevels: Scoring;
  targetScore:number;
  levelMap: LevelMapNameValues;
  friction: number;
  lives: number;
  gameplayBackground:string,
  levelBackground:string,
  levelBackgroundAtlas:string,
  bumperDownKey:string,
  tutorialStep:TutorialStepsValues[],
  arrowColor:number,
  bgMusic:string
}

export interface Scoring {
  smashLevels: number[];
}

export interface WorldPack{
  worldName:string,
  background:string,
  assetPack:string,
  levels:string[];
}

export const Worlds = [
  {
    worldName:"Desert",
    background:"bg-lvl-desert.jpg",
    assetPack:"asset-pack-game-desert",
    levels:[
      LevelName.Level1,
      LevelName.Level2,
      LevelName.Level3,
      LevelName.Level4
    ]
  },
  {
    worldName:"farm",
    background:"bg-lvl-country.jpg",
    assetPack:"asset-pack-game-country",
    levels:[
      LevelName.Level5,
      LevelName.Level6,
      LevelName.Level7,
      LevelName.Level8
    ]
  },
  {
    worldName:"ice",
    background:"bg-lvl-ice.jpg",
    assetPack:"asset-pack-game-ice",
    levels:[
      LevelName.Level9,
      LevelName.Level10,
      LevelName.Level11,
      LevelName.Level12
    ]
  },
  {
    worldName:"space",
    background:"bg-lvl-space.jpg",
    assetPack:"asset-pack-game-space",
    levels:[
      LevelName.Level13,
      LevelName.Level14,
      LevelName.Level15,
      LevelName.Level16
    ]
  }
]
